import { clsx } from 'clsx'

export type ComplianceStatus =
  | 'compliant'
  | 'action-required'
  | 'expiring'
  | 'pending'

// Status colors per Master Architecture Decision 10 (compliance card mocks).
const styles: Record<
  ComplianceStatus,
  { label: string; dot: string; text: string; ring: string; bg: string }
> = {
  compliant: {
    label: 'Compliant',
    dot: 'bg-emerald-600',
    text: 'text-emerald-700',
    ring: 'ring-emerald-600/20',
    bg: 'bg-emerald-50',
  },
  'action-required': {
    label: 'Action Required',
    dot: 'bg-red-600',
    text: 'text-red-700',
    ring: 'ring-red-600/20',
    bg: 'bg-red-50',
  },
  expiring: {
    label: 'Expiring Soon',
    dot: 'bg-amber-500',
    text: 'text-amber-700',
    ring: 'ring-amber-500/20',
    bg: 'bg-amber-50',
  },
  pending: {
    label: 'Pending',
    dot: 'bg-blue-500',
    text: 'text-blue-700',
    ring: 'ring-blue-500/20',
    bg: 'bg-blue-50',
  },
}

export function StatusBadge({
  status,
  label,
  className,
}: {
  status: ComplianceStatus
  label?: string
  className?: string
}) {
  const style = styles[status]
  return (
    <span
      className={clsx(
        className,
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset',
        style.bg,
        style.text,
        style.ring,
      )}
    >
      <span
        aria-hidden="true"
        className={clsx('size-1.5 rounded-full', style.dot)}
      />
      {label ?? style.label}
    </span>
  )
}
